import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7db3df9e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "pagination"
};
var _hoisted_2 = {
  class: "page"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_pagination = _resolveComponent("el-pagination");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 分页数据 "), _withDirectives(_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_pagination, {
    background: "",
    layout: "prev, pager, next",
    total: _ctx.total,
    "page-size": _ctx.pageInfo.limit,
    "current-page": _ctx.curtPage,
    onCurrentChange: _ctx.changeCurrent
  }, null, 8
  /* PROPS */
  , ["total", "page-size", "current-page", "onCurrentChange"])], 512
  /* NEED_PATCH */
  ), [[_vShow, _ctx.total]])]);
}